import { Injectable } from '@angular/core';
import { ActiconSceneLightComponentHandler } from './scene-light/scene-light-handler';
import { ComponentHandlerProvider } from '@magicore/visualize-3d';
import { acticonV3dComponentNames } from './acticon-v3d-component-names';
import { ActiconInteractiveComponentHandler } from './acticon-interactive/acticon-interactive-component-handler';

@Injectable({
  providedIn: 'root'
})
export class ActiconV3dComponentsService {
  private registered = false;

  constructor(private componentHandlerProvider: ComponentHandlerProvider, private interactiveHandler: ActiconInteractiveComponentHandler) {}

  /**
   * Register custom acticon V3D components, if not yet registered
   */
  public tryRegisterCustomComponents(): void {
    if (this.registered) {
      return;
    }

    // List of custom handlers for the custom V3D components. Add more if needed.
    this.componentHandlerProvider.registerHandlerType('ActiconSceneLight', new ActiconSceneLightComponentHandler());
    this.componentHandlerProvider.registerHandlerType(acticonV3dComponentNames.interactive, this.interactiveHandler);

    // We only want to register them once
    this.registered = true;
  }
}
